// extracted by mini-css-extract-plugin
export default {"container":"CircularProcess_container__dADJz","verticalLayout":"CircularProcess_verticalLayout__Si5iW"};